<template>
  <div class="previews">
    <v-layout row px-4 class="search-header">
      <v-flex xs12 px-4 pt-4>
        <h1  v-if="screenNumber === 2" class="text-xs-center">Navigation Components</h1>
        <h1  v-if="screenNumber === 3" class="text-xs-center">Homepage Components</h1>
        <h1  v-if="screenNumber === 4" class="text-xs-center">Footer Components</h1>
        <v-layout :class="{ 'row justify-center column': isMobile600, 'row justify center': !isMobile600}" v-else>
          <v-flex md6 px-3>
            <v-text-field
              hide-details
              :prepend-icon="!isMobile600 ? 'search' : undefined"
              single-line
              v-model="search"
              placeholder="Search Components"
            ></v-text-field>
          </v-flex>
          <v-flex v-if="screenNumber === 3" md6 px-3>
            <v-select
              :items="typeList"
              v-model="selectedType"
              clearable
              @click:clear="emptyAll"
              attach
              label="Filter By Type"
              @input="typeFilter(selectedType)"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <div class="nav-components" v-if="screenNumber === 2">
      <v-layout row layout wrap v-if="search !== ''">
        <v-container grid-list-xl fluid pb-5 pl-3 pt-5 pr-5 fill-height>
          <v-layout row wrap>
            <component-preview v-for="component in searchItems(navComponents)" :key="component.id" :component="component" :types="component.type" :previews="component.previews"></component-preview>
          </v-layout>
        </v-container>
      </v-layout>
      <div v-else>
        <div v-for="t in navComponentTypes" :key="t.type">
          <v-layout row layout wrap pb-5 class="component-section" v-if="searchItemsWithType(navComponents, t.type).length > 0">
            <v-flex xs12 pl-3 pr-5 pb-4 pt-5>
              <div class="type-card">
                <h2 class="type-header">{{t.heading}}</h2>
                <p class="type-explanation">{{t.explanation}}</p>
              </div>
            </v-flex>
            <v-container grid-list-xl fluid py-0 pl-3 pr-5 fill-height>
              <v-layout row wrap>
                <component-preview v-for="component in searchItemsWithType(navComponents, t.type)" :key="component.id" :component="component" :types="component.type" :previews="component.previews"></component-preview>
              </v-layout>
            </v-container>
          </v-layout>
        </div>
      </div>
    </div>

    <div class="homepage-components" v-if="screenNumber === 3">
      <v-layout row layout wrap v-if="search !== '' && (typeof selectedType === 'undefined' || selectedType === '')">
        <v-container grid-list-xl fluid pb-5 pl-3 pt-5 pr-5 fill-height>
          <v-layout row wrap>
            <component-preview v-for="component in searchItems(bodyComponentsToShow)" :key="component.id" :component="component" :types="component.type" :previews="component.previews"></component-preview>
          </v-layout>
        </v-container>
      </v-layout>
      <div v-else>
        <div v-for="t in componentTypes" :key="t.type">
          <v-layout row layout wrap pb-5 class="component-section" v-if="((selectedType === t.type || typeof selectedType === 'undefined' || selectedType === '') && searchItemsWithType(bodyComponentsToShow, t.type).length > 0)">
            <v-flex xs12 pl-3 pr-5 pb-4 pt-5>
              <div class="type-card">
                <h2 class="type-header">{{t.heading}}</h2>
                <p class="type-explanation">{{t.explanation}}</p>
              </div>
              
            </v-flex>
            <v-container grid-list-xl fluid py-0 pl-3 pr-5 fill-height>
              <v-layout row wrap>
                <component-preview v-for="component in searchItemsWithType(bodyComponentsToShow, t.type)" :key="component.id" :component="component" :types="component.type" :previews="component.previews"></component-preview>
              </v-layout>
            </v-container>
          </v-layout>
        </div>
      </div>
    </div>
    <div class="footer-components" v-if="screenNumber === 4">
      <v-layout row layout wrap v-if="search !== ''">
        <v-container grid-list-xl fluid pb-5 pl-3 pt-5 pr-5 fill-height>
          <v-layout row wrap>
            <component-preview v-for="component in searchItems(footerComponents)" :key="component.id" :component="component" :types="component.type" :previews="component.previews"></component-preview>
          </v-layout>
        </v-container>
      </v-layout>
      <div v-else>
        <div v-for="t in footerComponentTypes" :key="t.type">
          <v-layout row layout wrap pb-5 class="component-section" v-if="searchItemsWithType(footerComponents, t.type).length > 0">
            <v-flex xs12 pl-3 pr-5 pb-4 pt-5>
              <div class="type-card">
                <h2 class="type-header">{{t.heading}}</h2>
                <p class="type-explanation">{{t.explanation}}</p>
              </div>
            </v-flex>
            <v-container grid-list-xl fluid py-0 pl-3 pr-5 fill-height>
              <v-layout row wrap>
                <component-preview v-for="component in searchItemsWithType(footerComponents, t.type)" :key="component.id" :component="component" :types="component.type" :previews="component.previews"></component-preview>
              </v-layout>
            </v-container>
          </v-layout>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import screenMixin from '../mixins/screenMixin';
import ComponentPreview from './ComponentPreview'

export default {
  mixins: [screenMixin],
  props: ['screenNumber'],
  data() {
    return {
      componentTypes: this.$store.state.componentTypes,
      navComponentTypes: this.$store.state.navComponentTypes,
      footerComponentTypes: this.$store.state.footerComponentTypes,
      brand: this.$store.state.chosenBrand,
      selectedType: '',
      search: '',
      bodyComponentsToShow: []
    }
  },
  mounted() {
    this.bodyComponentsToShow = this.bodyComponents;
  },
  computed: {
    navComponents() {
      return this.availableComponents(this.$store.state.navComponents);
    },
    bodyComponents() {
      return this.availableComponents(this.$store.state.bodyComponents);
    },
    footerComponents() {
      return this.availableComponents(this.$store.state.footerComponents);
    },
    typeList() {
      var allT = []
      this.componentTypes.map(function(c) {
        allT.push(c.type);
      });
      return allT
    }
  },
  methods: {
    availableComponents(all) {
      const brand = (this.brand || 'none').toLowerCase().trim();

      // Sort items with priority → packaged → newer → old
      const sortedItems = all.slice().sort((a, b) => {
        // Priority first
        if (typeof a.priority === 'number' && typeof b.priority === 'number') {
          return a.priority - b.priority;
        }

        // If only one has priority, that comes first
        if (typeof a.priority === 'number') return -1;
        if (typeof b.priority === 'number') return 1;

        // Packaged next
        if ((a.packages && a.packages.length > 0) && (!b.packages || b.packages.length === 0)) return -1;
        if ((b.packages && b.packages.length > 0) && (!a.packages || a.packages.length === 0)) return 1;

        // Newer before old
        if (a.newer && !b.newer) return -1;
        if (b.newer && !a.newer) return 1;

        return 0;
      });

      // Filter by brand rules
      return sortedItems.filter((item) => {
        const exclusive = (item.exclusive || []).map(e => e.toLowerCase().trim());
        const excludeFrom = (item.exclude_from || []).map(e => e.toLowerCase().trim());

        if (brand === 'none') {
          // Only include items that are NOT exclusive
          return exclusive.length === 0;
        }

        if (exclusive.length > 0) {
          return exclusive.includes(brand);
        }

        if (excludeFrom.length > 0) {
          return !excludeFrom.includes(brand);
        }

        return true;
      });
    },
    searchItems(items) {
      if (this.search !== '' && typeof this.search !== 'undefined') {
        return items.filter((i) => {
          var lTitle = i.title.toLowerCase();
          var lSearch = this.search.toLowerCase();
          return lTitle.match(lSearch);
        });
      }
      return items;
    },
    searchItemsWithType(items, t) {
      let typeItems = items.filter((item) => {
        if (item.type.indexOf(t) > -1) {
          return item;
        }
      });
      if (this.search !== '' && typeof this.search !== 'undefined') {
        return typeItems.filter((i) => {
          var lTitle = i.title.toLowerCase();
          var lSearch = this.search.toLowerCase();
          return lTitle.match(lSearch);
        });
      }
      return typeItems;
    },
    typeFilter(val) {
      if (typeof val !== 'undefined' && val !== ''){
        this.bodyComponentsToShow = this.bodyComponents.filter(function(item){
          if (item.type.indexOf(val) > -1) {
            return item;
          }
        });
      }
    },
    emptyAll() {
      this.$nextTick(() => {
        this.bodyComponentsToShow = this.bodyComponents;
        this.search = '';
        this.selectedType = '';
      })
    }
  },
  watch: {
    screenNumber() {
      this.emptyAll();
    }
  },
  components: {
    componentPreview: ComponentPreview
  }
}
</script>

<style>
.previews .v-select .v-menu__content {
  max-height: 405px !important;
}
</style>

<style scoped>
  .previews .search-header h1 {
    color: #006aff;
    font-size: 3em;
    font-weight: 500;
  }
  .previews h2.type-header {
    color: #006aff;
    margin-bottom: 10px;
  }
  .previews p.type-explanation {
    font-size: 16px;
  }
  .previews .type-card {
    background: #EAF7FC;
    padding: 30px;
  }
</style>
